"use client";

import { Clock, MapPin } from "lucide-react";
import { useTranslations } from "next-intl";
import TitleH3 from "../fonts/TitleH3";

interface VacancyProps {
  title: string;
  location: string;
  time: string;
  task1?: string;
  task2?: string;
  task3?: string;
  task4?: string;
  task5?: string;
  profile1?: string;
  profile2?: string;
  profile3?: string;
  profile4?: string;
  profile5?: string;
  profile6?: string;
}

const Vacancy = ({ ...props }: VacancyProps) => {
  const t = useTranslations("vacancies.vacancies");

  return (
    <div className="gs--vacancy-card mt-8 rounded-lg p-16 shadow-lg transition-[box-shadow,transform] duration-300 ease-out hover:-translate-y-0.5 hover:shadow-xl">
      <TitleH3 title={props.title} />
      <div className="mt-4 flex items-center gap-2">
        <MapPin className="text-primary" />
        <p className="text-ring">{props.location}</p>
        <Clock className="text-primary" />
        <p className="text-ring">{props.time}</p>
      </div>
      <p className="text-ring my-4">{t("tasks")}:</p>
      <ul className="text-ring ml-6 list-disc">
        <li>{props.task1}</li>
        {props.task2 ? <li>{props.task2}</li> : ""}
        {props.task3 ? <li>{props.task3}</li> : ""}
        {props.task4 ? <li>{props.task4}</li> : ""}
        {props.task5 ? <li>{props.task5}</li> : ""}
      </ul>
      <p className="text-ring my-4">{t("profile")}:</p>
      <ul className="text-ring ml-6 list-disc">
        <li>{props.profile1}</li>
        <li>{props.profile2}</li>
        <li>{props.profile3}</li>
        <li>{props.profile4}</li>
        {props.profile5 ? <li>{props.profile5}</li> : ""}
        {props.profile6 ? <li>{props.profile6}</li> : ""}
      </ul>
      <p className="text-ring mt-4">{t("interest")}</p>
    </div>
  );
};

export default Vacancy;
